type Props = {
  size?: number;
  className?: string;
  title?: string;
};

/**
 * Lagamobilen Access — märket. Två överlappande L-former i guld.
 * Använder currentColor så den enkelt kan färgsättas via parent (text-[var(--color-gold)]).
 */
export function AccessIcon({ size = 28, className = "", title }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      role={title ? "img" : "presentation"}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <g transform="translate(1,1.85) scale(0.367) translate(-4.5,-5.7)">
        <path
          opacity="0.5"
          fill="currentColor"
          d="M33.4,59.6L32,61c-3.3,3.3-8.7,3.3-12,0L4.5,45.4c-3.3-3.3-3.3-8.7,0-12L29.1,8.8l7.4,7.4L13.3,39.4L33.4,59.6z"
        />
        <path
          fill="currentColor"
          d="M61.2,31.9L36.3,56.7l-7.4-7.4l23.5-23.5L32.2,5.7l1.4-1.4c3.3-3.3,8.7-3.3,12,0l15.6,15.6C64.5,23.2,64.5,28.5,61.2,31.9z"
        />
      </g>
    </svg>
  );
}

export default AccessIcon;
